module.exports = __webpack_public_path__ + "static/img/1.d46f314.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/1.png
// module id = wWug
// module chunks = 0